export default __webpack_public_path__ + "static/4efec4234292e81ec3852094c3ff2396.png";